/* ============================================================
   SSS Boutique — wishlist.js
   Shopify has no native wishlist, so this is a lightweight
   localStorage implementation. Swap for an app later if you
   need cross-device sync.
   ============================================================ */
(function () {
  'use strict';
  const KEY = 'ethnic_wishlist_v1';
  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));

  const read = () => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } };
  const write = (items) => { localStorage.setItem(KEY, JSON.stringify(items)); paint(); };
  const has = (handle) => read().some(i => i.handle === handle);

  /* Lucide "heart" (ISC License) — mirrors snippets/icon.liquid so the
     JS-rendered heart matches the Liquid-rendered one exactly. */
  const HEART_PATH = 'M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z';
  const HEART = (filled) =>
    '<svg class="icon" width="24" height="24" viewBox="0 0 24 24" ' +
    (filled
      ? 'fill="currentColor" stroke="none"'
      : 'fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"') +
    ' aria-hidden="true" focusable="false"><path d="' + HEART_PATH + '"/></svg>';

  const add = (item) => { const items = read(); if (!items.some(i => i.handle === item.handle)) { items.push(item); write(items); } };
  const remove = (handle) => write(read().filter(i => i.handle !== handle));

  const updateCount = () => {
    const n = read().length;
    $$('[data-wishlist-count]').forEach(el => el.textContent = n);
  };

  /* Reflect active state on all product-card hearts */
  const paintHearts = () => {
    $$('[data-product-card]').forEach(card => {
      const toggle = $('[data-wishlist-toggle]', card);
      if (!toggle) return;
      const active = has(card.getAttribute('data-handle'));
      toggle.classList.toggle('is-active', active);
      toggle.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
      toggle.setAttribute('aria-pressed', active ? 'true' : 'false');
      // Lucide "heart" (ISC) - kept in sync with snippets/icon.liquid
      toggle.innerHTML = HEART(active);
    });
  };

  /* Bind heart buttons */
  const bindHearts = () => {
    $$('[data-product-card]').forEach(card => {
      const toggle = $('[data-wishlist-toggle]', card);
      if (!toggle || toggle.dataset.bound) return;
      toggle.dataset.bound = '1';
      toggle.addEventListener('click', (e) => {
        e.preventDefault();
        const handle = card.getAttribute('data-handle');
        if (has(handle)) { remove(handle); }
        else {
          add({
            handle: handle,
            id: card.getAttribute('data-id'),
            title: card.getAttribute('data-title'),
            price: card.getAttribute('data-price'),
            image: card.getAttribute('data-image'),
            url: card.getAttribute('data-url')
          });
        }
      });
    });
  };

  /* ---------- Wishlist page rendering ---------- */
  const renderWishlistPage = () => {
    const grid = $('[data-wishlist-grid]');
    if (!grid) return;
    const items = read();
    const empty = $('[data-wishlist-empty]');
    const total = $('[data-wishlist-total]');
    const tpl = $('[data-wishlist-card-template]');

    if (total) total.textContent = items.length + ' Item' + (items.length === 1 ? '' : 's');
    grid.innerHTML = '';

    if (!items.length) { if (empty) empty.hidden = false; return; }
    if (empty) empty.hidden = true;

    items.forEach(item => {
      const node = tpl.content.firstElementChild.cloneNode(true);
      node.setAttribute('data-handle', item.handle);
      const link = $('.wishlist-card__media', node);
      const img = $('img', node);
      link.href = item.url; img.src = item.image || ''; img.alt = item.title || '';
      $('[data-title]', node).textContent = item.title || '';
      $('[data-price]', node).textContent = item.price || '';
      $('[data-view]', node).href = item.url;
      $('[data-remove]', node).addEventListener('click', () => remove(item.handle));
      grid.appendChild(node);
    });
  };

  /* Move all to bag: add first available variant of each item, then go to cart */
  const moveAllToBag = async () => {
    const items = read();
    if (!items.length) return;
    for (const item of items) {
      try {
        const res = await fetch('/products/' + item.handle + '.js');
        if (!res.ok) continue;
        const product = await res.json();
        const variant = (product.variants || []).find(v => v.available) || product.variants[0];
        if (!variant) continue;
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variant.id, quantity: 1 })
        });
      } catch (e) { /* skip */ }
    }
    window.location.href = '/cart';
  };

  const bindWishlistControls = () => {
    $$('[data-wishlist-clear]').forEach(b => b.addEventListener('click', () => {
      if (confirm('Clear your entire wishlist?')) write([]);
    }));
    $$('[data-wishlist-move-all]').forEach(b => b.addEventListener('click', moveAllToBag));
  };

  const paint = () => { updateCount(); paintHearts(); renderWishlistPage(); };

  document.addEventListener('DOMContentLoaded', () => {
    bindHearts();
    bindWishlistControls();
    paint();
  });

  /* Product cards injected after load (e.g. the recommendations swap
     in theme.js) need their hearts bound and painted too. */
  document.addEventListener('theme:cards-added', () => { bindHearts(); paintHearts(); });
  // In case DOM already ready
  if (document.readyState !== 'loading') { bindHearts(); bindWishlistControls(); paint(); }
})();
